import React, { useState } from "react";
import { Link } from "react-router-dom"; // ✅ Add this
import "./navbar.css";
import Logo from "../../assets/Logo.png";

function NavBar() {
  const [value, setValue] = useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <nav className="navbar">
      <div className="main-nav">
        <Link to="/">
          <img src={Logo} alt="Logo" className="logo" />
        </Link>

        <ul className="main-nav-list">
          <li>
            <Link className="main-nav-link" to="/news-events">
              News & Events
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/project">
              Project
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/about-us">
              About Us
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/contact">
              Contact
            </Link>
          </li>
        </ul>
      </div>
      <div className="sub-nav">
        <button className="nav-btn">
          <i className="fa-solid fa-magnifying-glass"></i>
        </button>
        <button className="nav-btn">
          <i className="fa-regular fa-heart"></i>
        </button>
        <button className="nav-btn">
          <i className="fa-regular fa-user"></i>
        </button>
      </div>
    </nav>
  );
}

export default NavBar;
